import { DesignSelect } from "@/components/ui/design-select"
import { cx } from "@/lib/utils/cx"

export const US_STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
] as const

// USStateSelect — exposes the same event-based API as the old native
// <select> so existing callers don't have to change, but renders our
// DesignSelect underneath. Same chrome (rounded-2xl popover, soft shadow,
// emerald check pill) as every other dropdown in Settings/onboarding.
interface USStateSelectProps {
  id?: string
  value?: string
  onChange?: (e: { target: { value: string } }) => void
  placeholder?: string
  className?: string
  disabled?: boolean
}

export function USStateSelect({
  id,
  value,
  onChange,
  placeholder = "State",
  className,
  disabled,
}: USStateSelectProps) {
  return (
    <DesignSelect.Root
      value={value || undefined}
      onValueChange={(v) => onChange?.({ target: { value: v } })}
      disabled={disabled}
    >
      <DesignSelect.Trigger
        id={id}
        className={cx(
          "text-left flex items-center justify-between",
          !value && "text-zinc-400",
          className,
        )}
      >
        <DesignSelect.Value placeholder={placeholder} />
      </DesignSelect.Trigger>
      <DesignSelect.Content>
        {US_STATES.map((s) => (
          <DesignSelect.Item key={s} value={s}>
            {s}
          </DesignSelect.Item>
        ))}
      </DesignSelect.Content>
    </DesignSelect.Root>
  )
}
